import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { formatAmount, formatDate } from './auction_formatter';

$(() => {
  const liveBiddingTableContent = $('#live-bidding-table .table__content');
  const translatedMe = liveBiddingTableContent.attr('data-translated-me');
  const timezoneName = liveBiddingTableContent.attr('data-timezone-name');

  const addNewRowToTable = ({
    bidderId,
    userBidderId,
    amount,
    bidTime,
    isOutbidByPriorityBid,
  }) => {
    // dates provided by bidhub are in UTC
    const bidTimeWithOffset = `${bidTime}+00:00`;
    const date = new Date(bidTimeWithOffset);
    const dateFormatted = formatDate(date, { timeZone: timezoneName });
    const amountFormatted = formatAmount(amount);
    const bidderLabel = bidderId === userBidderId ? translatedMe : bidderId;
    const newRow = `
            <div class="table__row ${
              isOutbidByPriorityBid ? 'table__row--warning' : ''
            }">
                <div class="table__cell" data-bidder-id="${bidderId}">${bidderLabel}${
      isOutbidByPriorityBid
        ? '<button class="outbid-by-priority__button" @click="showPopover=true, setPopoverPosition()"></button>'
        : ''
    }
                </div>
                <div class="table__cell"><strong>${amountFormatted}</strong></div>
                <div class="table__cell">${dateFormatted}</div>
            </div>
        `;
    liveBiddingTableContent.append(newRow);
  };

  const reloadLiveBiddingTable = ({ bids, userBidderId = null }) => {
    if (bids?.length) {
      liveBiddingTableContent.empty();
      bids.forEach((bid) => {
        const {
          BidderId: bidderId,
          Amount: amount,
          Date: bidTime,
          IsOutbidByPriorityBid: isOutbidByPriorityBid,
        } = bid;
        addNewRowToTable({
          bidderId,
          amount,
          bidTime,
          userBidderId,
          isOutbidByPriorityBid,
        });
      });
    }
  };

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_STATUS_UPDATED, (event) => {
    const { bids, userBidderId } = event;
    reloadLiveBiddingTable({ bids, userBidderId });
  });
});
